import ON_THE_BEACH_AGENCY_IDS from './onTheBeachAgencyIds';

class AuthService {
    constructor($state, $q, cacheService, OAuth, OAuthToken) {
        'ngInject';
        this.$state = $state;
        this.$q = $q;
        this.OAuth = OAuth;
        this.OAuthToken = OAuthToken;
        this.authenticated = this.OAuth.isAuthenticated();
        this.cacheService = cacheService;
    }

    loginByBookingReferenceAndCustomerEmail(reference, email) {
        return this._authenticate({
            reference,
            email,
        });
    }

    loginByAgencyBookingReferenceAndCustomerSurname(agencyBookingReference, customerSurname) {
        return this._authenticate({
            agency_reference: agencyBookingReference,
            surname: customerSurname,
            'agency_id[]': ON_THE_BEACH_AGENCY_IDS
        });
    }

    _authenticate(credentials) {
        return this.OAuth.getAccessToken(credentials).then((response) => {
            this.authenticated = true;
            return response;
        });
    }

    logout() {
        this.clearSession();
        return this.$q.when();
    }

    clearSession() {
        this.OAuthToken.removeToken();
        this.cacheService.clear();
        this.authenticated = false;
    }

    getAccessToken() {
        return this.OAuthToken.getAccessToken();
    }
}

export default AuthService;



// WEBPACK FOOTER //
// ./client/app/common/auth/auth.service.js